import {useCreatorStudioStore} from "../stores/CreatorStudioStore";
import {EventBus} from "../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../events/app.events";
import { JOB_STATE_DRAFT } from '../const/job.const';
import JobManager from "./JobManager";
import {testIsNotUndefined} from "../../../../../../lib/test-and-assert/test-base";

class StudioManager {

    listener = false;

    constructor() {
    }

    openJob(id, previousId = null, openHistory = false) {
        this.store = useCreatorStudioStore();

        if (previousId !== null) {
            let previousJob = this.store.getJobById(previousId);
            if (previousJob.state === JOB_STATE_DRAFT) {
                previousJob.settings = JSON.parse(JSON.stringify(this.store.getSettings()));
            }
        }

        if (openHistory === true) {
            EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}/history`, {})
        } else {
            EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}/canvas`, {});
        }

        this.store.updateSettings(JSON.parse(JSON.stringify(this.store.getJobById(id).settings)));
    }

    newJob(previousId = null) {
        const jobId = JobManager.create();
        this.openJob(jobId, previousId);
    }

    openWelcomeJob() {
        this.store = useCreatorStudioStore();
        const jobs = this.store.creatorStudio.jobs;
        
        const fragmentData = qgQueryFragmentHelper.getCurrentFragmentData();
        const jobID = fragmentData?.j;

        const submitedJob = jobs.find(job => job?.apiJob?.id === jobID);
        
        if (testIsNotUndefined(jobID)) {
            if (!submitedJob) {
                const id = JobManager.create();
                
                JobManager.submitFromJobId(id, jobID);
            } else {
                this.openJob(submitedJob?.id);
            }
            return;
        }

        const openJobs = jobs.filter(job => job.isOpen === true);
        const lastOpenJob = openJobs[openJobs.length - 1]; 

        if (!lastOpenJob || this.store.creatorStudio.isMobile === true) {
            const id = JobManager.create();
            
            EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}/welcome`, {})
            this.store.updateSettings(JSON.parse(JSON.stringify(this.store.getJobById(id).settings)));
        } else {
            this.openJob(lastOpenJob?.id);
        }
    }

    watchMobile() {
        this.store = useCreatorStudioStore();

        addEventListener("resize", (event) => {
            this.updateMobile();
        });
    }

    updateMobile() {
        let isMobile = window.matchMedia('(max-width: 1200px)').matches;
        this.store.creatorStudio.isMobile = isMobile;
    }
}

export default new StudioManager()